module.exports = __webpack_public_path__ + "static/1323957894.08c59556.jpg";